import React, { useMemo } from 'react';

export enum LoadingSpinnerType {
	Basic = 'basic',
	Gradient = 'gradient',
}

interface LoadingSpinnerProps {
	height?: number;
	width?: number;
	stroke?: number;
	color?: string;
	style?: React.CSSProperties;
	type?: LoadingSpinnerType;
	percHeight?: number;
	percWidth?: number;

}

export default function LoadingSpinner(props: LoadingSpinnerProps) {
	const {
		height = 50,
		width = 50,
		stroke = 3,
		color = '#ffffff',
		style = {},
		type = 'basic',
		percHeight,
		percWidth
	} = props;

	const transform = useMemo(() => {
		const baseWidth = 102;
		const perc = (width / baseWidth);
		return `scale(${perc})`;	
	}, [width])

	return (type === 'gradient'
		? <div className="embed-chat-loading-info" style={{transform, ...style}}>
			<div className="container">
				{/* oddly, if you make these int0 <div/>'s, they break */}
				<div id='test-id' className="loader"></div>
				<div className="emptyspace"></div>
				<div className="spinner" ></div>
				<div className="box1-embed"></div>
				<div className="box2-embed"></div>
			</div>
		</div>
		: <div
			data-testid="loading-spinner"
			style={{
				height: percHeight ? `${percHeight}%` : height,
				width: percWidth ? `${percWidth}%` : width,
				maxHeight: height,
				maxWidth: width,
				transform: 'rotate(-90deg)',
				margin: '0 auto',
				...style,
			}}
		>
			<svg
				width="100%"
				height="100%"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 100 100"
				preserveAspectRatio="xMidYMid"
				className="lds-rolling"
			>
				<circle
					style={{ animation: '2s loading linear infinite' }}
					cx="50"
					cy="50"
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeWidth={stroke}
					r="35"
					strokeDasharray="219.9"
				/>
			</svg>
		</div>
	);
}
